import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_create_promotion_data: { message: "idle" },
};

export const retrieve_create_promotion_data_Slice = createSlice({
 name: "retrieve_create_promotion_data",
 initialState,
 reducers: {
  success_retrieve_create_promotion_data: (state, action) => {
   state.retrieve_create_promotion_data = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_create_promotion_data: (state, action) => {
   state.retrieve_create_promotion_data = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_create_promotion_data: (state) => {
   state.retrieve_create_promotion_data = { status: app_consts.IDLE };
  },
  loading_retrieve_create_promotion_data: (state) => {
   state.retrieve_create_promotion_data = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_create_promotion_data, fail_retrieve_create_promotion_data, reset_retrieve_create_promotion_data, loading_retrieve_create_promotion_data } = retrieve_create_promotion_data_Slice.actions;

export default retrieve_create_promotion_data_Slice.reducer;